import React from 'react';
import {
  reduxForm,
} from 'redux-form';
import { Alert, Modal, Spinner } from 'react-bootstrap';
import { withRouter } from 'react-router';
import { Show } from 'Layout';
import { PageStatus } from 'enums';
import { NewsLetterAPI, SamplesAPI } from "../../API";
import CreatableSelect from 'react-select/creatable';
import Select from 'react-select';
import moment from "moment/moment";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import csvtojson from "csvtojson";
import { CURRENCY_SYMBOL } from 'Helper/currency';
import country from 'config/countryConfig';

export type FormValue = {
  name: string,
};


type State = {
  status: string,
  error: string | null,
  data: any,
  name: string,
};

class Form extends React.Component<any, any> {
  constructor(props) {
    super(props);
    this.state = {
      status: PageStatus.None,
      samples: '',
      error: null,
      data: '',
      name: "",
      subject: "",
      "sendDate": "",
      "newsletterStatus": 'inProgress',
      // Default body intentionally empty (was: 84 lines of legacy AngularJS-editor markup, removed 2026-05-04)
      body: '',
      emails: [],
      phoneNumbers: [],
      userIds: [],
      createdById: '',
      selectedSampleOption: '',
      bulkEmailSheet: '',
      // bulkEmailSheet: '',
      bulkPhoneNumbersSheet: '',
      bulkuserIdsSheet: '',
      disableEmails: false,
      disablePhoneNumbers: true, // Phone number inputs disabled by default
      disableUserIds: true, // User ID inputs disabled by default
      allTempletes: [],
      selectedTempleteDescription: '',
      showHideSelectTempField: '',
      notificationType: 'email', // Default to 'email'
      disableBulkEmailSheet: false, // Bulk email upload enabled by default
      disablebulkPhoneNumbersSheet: true, // Bulk phone number upload disabled by default
      disablebulkuserIdsSheet: true, // Bulk user ID upload disabled by default
      tempId: '',
      cat: '',
      showHideCustomSelectBox: false,
    };
    this.selectRef = React.createRef();
    this.optionsRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside);
    if (this.props.id) {
      this.fetchDetails();
    } else {
      this.getAllTempletesFunc({ "type": "normal" });
      this.fetchSampleList();
    }
  }

  fetchDetails() {
    Promise.resolve()
      .then(() => this.setState({ status: PageStatus.Loading }))
      .then(() => {
        if (!this.props.id) {
          return Promise.reject(new Error('Invalid ID'));
        }

        return NewsLetterAPI.getOne(this.props.id);
      })
      .then((data) => {
        this.initializeValues(data);
        this.setState({
          data,
          status: PageStatus.Loaded,
        }, () => {
          this.fetchSampleList()
        });
      })
      .catch((error) => {
        this.setState({ status: PageStatus.Error, error: error.message });
      });
  }

  fetchSampleList(): Promise<void> {
    return Promise.resolve()
      .then(() => this.setState({ status: PageStatus.Loading }))
      .then(() => SamplesAPI.getAll("All", 1, {}))
      .then((samplesList: any) => {
        const options = (samplesList?.data || []).map(sample => ({
          label: sample.name,
          value: sample.id
        }));
        if (this.state.sample_id) {
          const option = options.find(item => item.value === this.state.sample_id);
          this.setState({ selectedSampleOption: option });
        }
        this.setState({ samples: options, status: PageStatus.Loaded });
      })
      .catch((error) => {
        this.setState({ error: error.message, status: PageStatus.Error });
      });
  }

  formValues() {
    return {
      name: this.state.name,
      subject: this.state.subject,
      "sendDate": this.state.sendDate,
      "newsletterStatus": this.state.newsletterStatus,
      "body": this.state.body,
      "emails": this.state.emails,
      "phoneNumbers": this.state.phoneNumbers,
      "userIds": this.state.userIds,
      createdById: this.props.userId,
      bulkEmailSheet: this.state.bulkEmailSheet,
      bulkPhoneNumbersSheet: this.state.bulkPhoneNumbersSheet,
      bulkuserIdsSheet: this.state.bulkuserIdsSheet,
      disablebulkuserIdsSheet: this.state.disablebulkuserIdsSheet,
      notificationType: this.state.notificationType,
      tempId: this.state.tempId,
      cat: this.state.cat,
    };
  }

  initializeValues(data) {
    return this.setState({
      name: data.name,
      subject: data.subject,
      "sendDate": moment(data.sendDate).format("YYYY-MM-DD HH:mm").replace(" ", "T"),
      "newsletterStatus": data.newsletterStatus,
      "body": data.body,
      "emails": data.emails,
      createdById: this.props.userId,
      sample_id: data.newsletterSample ? data.newsletterSample.sample_id : null,
      tempId: data.tempId,
      cat: data.cat,
      notificationType: data.nofiType,
      disableEmails: data.nofiType !== 'email',
      disablePhoneNumbers: data.nofiType !== 'phoneNumber' && data.nofiType !== 'sms' && data.nofiType !== 'whatsapp',
      disableUserIds: data.nofiType !== 'userId',
      disableBulkEmailSheet: data.nofiType !== 'email',
      disablebulkPhoneNumbersSheet: data.nofiType !== 'phoneNumber' && data.nofiType !== 'sms' && data.nofiType !== 'whatsapp',
      disablebulkuserIdsSheet: data.nofiType !== 'userId',
    }, () => this.getAllTempletesFunc({ "type": data.nofiType == "email" || data.nofiType == "userId" ? "normal" : data.nofiType }));
  }
  onSubmit() {
    if (!this.props.id) {
      return this.create();
    }
    return this.update();
  }

  create() {
    const valuesIn = this.formValues();

    // Check if a bulk file is uploaded for emails, phone numbers, or user IDs
    const hasBulkFile = this.state.bulkEmailSheet || this.state.bulkPhoneNumbersSheet || this.state.bulkuserIdsSheet;
    const isSingleEmailTrue = this.state.emails.length > 0;
    const isSinglePhoneTrue = this.state.phoneNumbers.length > 0;
    const isSingleUserIdTrue = this.state.userIds.length > 0;
    const hasSingleValues = isSingleEmailTrue || isSinglePhoneTrue || isSingleUserIdTrue;
    if (hasBulkFile == "" && !hasSingleValues) {
      alert(`Please select values according to ${this.state.notificationType}`);
      return;
    }

    // Determine which API function to call based on the presence of a bulk file
    const apiRespo = hasBulkFile ? NewsLetterAPI.bulkcreate(valuesIn) : NewsLetterAPI.create(valuesIn);

    return Promise.resolve()
      .then(() => this.setState({ status: PageStatus.Submitting }))
      .then(() => apiRespo)
      .then((data) => {
        this.props.onSubmit(data.id);
        this.fetchDetails();
        return this.setState({ status: PageStatus.Submitted });
      })
      .catch((error) => {
        this.setState({ status: PageStatus.Error, error: error.message });
      });
  }

  update() {
    const valuesIn = this.formValues();
    return Promise.resolve()
      .then(() => this.setState({ status: PageStatus.Submitting }))
      .then(() => NewsLetterAPI.update(this.props.id, valuesIn))
      .then(() => {
        if (this.state.sample_id) {
          NewsLetterAPI.createSample({ sample_id: this.state.sample_id, newsletter_id: this.props.id })
        }
        this.setState({ status: PageStatus.Submitted });
        return this.props.onSubmit(this.props.id);
      })
      .catch((error) => {
        this.setState({ status: PageStatus.Error, error: error.message });
      });
  }

  handleCreateOption = (inputValue, type) => {
    const newOption = { value: inputValue.trim(), label: inputValue.trim(), type };
    if (type == "emails") {
      this.setState(prevState => ({
        [type]: [...prevState[type], newOption],
      }));
    } else {
      this.setState(prevState => ({
        [type]: [newOption],
      }));
    }
  };

  handleInputChange = (inputValue) => {
    let numberValidate = inputValue.replace(/\D/g, '');
    if (numberValidate.length > 10) { numberValidate = numberValidate.slice(0, 10); }
    return numberValidate;
  }

  handleChange = (selectedOptions, type) => {
    if (selectedOptions) {
      this.setState({ [type]: selectedOptions, [`${type}Sheet`]: '', [`disable${type}Sheet`]: true });
    } else {
      this.setState({ [type]: [], [`${type}Sheet`]: '', [`disable${type}Sheet`]: false });
    }
  };


  handleFileChange = async (event) => {

    const file = event.target.files[0];
    const inputName = event.target.name; // Get the input field's name attribute
    const type = inputName; // Extract type by removing 'bulk' from input name

    if (file) {
      try {
        const jsonData = await this.convertCsvToJson(file);
        const transformedData = jsonData.map((obj) => this.modifiedConvertedJson(obj, type));

        // Clear other states when new file is uploaded
        const newState = {
          bulkEmailFile: type === 'bulkEmail' ? file : this.state.bulkEmailFile,
          bulkPhoneNumbersFile: type === 'bulkPhoneNumbers' ? file : this.state.bulkPhoneNumbersFile,
          bulkUserIdsFile: type === 'bulkuserIds' ? file : this.state.bulkUserIdsFile,
          emails: [],
          phoneNumbers: [],
          userIds: [],
          disableEmails: true,
          disablePhoneNumbers: true,
          disableUserIds: true,
          [`${inputName}Sheet`]: transformedData,
          [`disable${type.charAt(0).toUpperCase() + type.slice(1)}`]: false, // Dynamically enable input based on the type
        };

        this.setState(newState);
      } catch (error) {
        console.error('Error converting CSV to JSON:', error);
      }
    } else {
      // Reset state if no file is provided
      this.setState({
        disableEmails: (type !== 'bulkEmail'),
        disablePhoneNumbers: (type !== 'bulkPhoneNumbers'),
        disableUserIds: (type !== 'bulkuserIds'),

      });
    }
  };

  handleSampleChange = async (selectedSampleOption) => {
    this.setState({ sample_id: selectedSampleOption.value, selectedSampleOption });
  };
  convertCsvToJson = (file: File): Promise<any[]> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const csvContent: any = reader.result;
        if (!csvContent.trim()) {
          reject(new Error('CSV content is empty.'));
          return;
        }
        csvtojson().fromString(csvContent).then(jsonData => resolve(jsonData))
      };
      reader.onerror = (event) => {
        const message = reader.error?.message ?? 'Unknown error during file reading';
        reject(new Error(message));
      };
      reader.readAsText(file);
    });
  };

  modifiedConvertedJson = (obj, type) => {
    switch (type) {
      case 'bulkuserIds':
        return {
          userId: obj.userId || '', // Include user ID if type is userIds
          name: obj.name || '',
        };
      case 'bulkPhoneNumbers':
        return {
          phoneNumber: obj.phoneNumber || '', // Include phone number for phone-based notifications
          name: obj.name || '',
        };
      case 'bulkEmail':
        return {
          email: obj.email || '', // Include email if type is emails
          name: obj.name || '',
        };
      default:
        return {}; // Return an empty object if no valid type is provided
    }
  };

  selectTempleteDescription = (id, optionName) => {
    let selectedValue = id;
    return Promise.resolve()
      .then(() => this.setState({ status: PageStatus.Submitting, selectedTempleteDescription: optionName }))
      .then(() => NewsLetterAPI.getonetempleates(selectedValue))
      .then((response) => {
        let responseData: any = response;
        this.setState({ status: PageStatus.Submitted, body: responseData.description != "" ? JSON.parse(responseData.description) : "", tempId: selectedValue, showHideCustomSelectBox: false });
      })
      .catch((error) => {
        this.setState({ status: PageStatus.Error, error: error.message, tempId: '' });
      });
  }

  showOptionsValue = () => { this.setState((prev) => { return { showHideCustomSelectBox: !prev.showHideCustomSelectBox } }); }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  }

  handleClickOutside = (e) => {
    if (
      this.selectRef.current && !this.selectRef.current.contains(e.target) &&
      this.optionsRef.current && !this.optionsRef.current.contains(e.target)
    ) {
      this.setState({ showHideCustomSelectBox: false });
    }
  };

  getAllTempletesFunc(type) {
    return Promise.resolve()
      .then(() => this.setState({ status: PageStatus.Submitting }))
      .then(() => NewsLetterAPI.getalltempleates(type))
      .then((response) => {
        let responseData: any = response;
        responseData.forEach((ele) => { if (ele.id == this.state.tempId) { this.setState({ selectedTempleteDescription: ele.name }) } });
        this.setState({ status: PageStatus.Submitted, allTempletes: responseData });
      })
      .catch((error) => {
        this.setState({ status: PageStatus.Error, error: error.message });
      });
  }

  deleteTemplate = (tempsId) => {
    return Promise.resolve()
      .then(() => this.setState({ status: PageStatus.Submitting }))
      .then(() => NewsLetterAPI.deletetempleates({ "id": tempsId }))
      .then((response) => {
        this.setState({ status: PageStatus.Submitted });
        this.getAllTempletesFunc({ "type": this.state.notificationType == "email" || this.state.notificationType == "userId" ? "normal" : this.state.notificationType });
      })
      .catch((error) => {
        this.setState({ status: PageStatus.Error, error: error.message });
      });
  }
  // ==================== Notification Function ===============================
  handleChangeCheckbox = (event) => {
    const value = event.target.value;

    this.setState((prevState) => ({
      notificationType: value,
      disableEmails: value !== 'email',
      disablePhoneNumbers: value !== 'phoneNumber' && value !== 'sms' && value !== 'whatsapp',
      disableUserIds: value !== 'userId',
      disableBulkEmailSheet: value !== 'email',
      disablebulkPhoneNumbersSheet: value !== 'phoneNumber' && value !== 'sms' && value !== 'whatsapp',
      disablebulkuserIdsSheet: value !== 'userId',
      // Reset fields when they are disabled
      emails: value === 'email' ? prevState.emails : [], // Reset emails if email is not selected
      phoneNumbers: (value === 'phoneNumber' || value === 'sms' || value === 'whatsapp') ? prevState.phoneNumbers : [], // Reset phoneNumbers if phoneNumber, sms or whatsapp is not selected
      userIds: value === 'userId' ? prevState.userIds : [], // Reset userIds if userId is not selected
      bulkEmailSheet: value === 'email' ? prevState.bulkEmailSheet : '', // Reset bulkEmailSheet if email is not selected
      bulkPhoneNumbersSheet: (value === 'phoneNumber' || value === 'sms' || value === 'whatsapp') ? prevState.bulkPhoneNumbersSheet : '', // Reset bulkPhoneNumbersSheet if phoneNumber, sms or whatsapp is not selected
      bulkuserIdsSheet: value === 'userId' ? prevState.bulkuserIdsSheet : '', // Reset bulkuserIdsSheet if userId is not selected
      cat: '',
      selectedTempleteDescription: '',
      tempId: '',
    }), () => this.getAllTempletesFunc({ "type": value == "email" || value == "userId" ? "normal" : value }));
  };



  // ===============================================================

  render() {
    const { notificationType } = this.state;
    const calculatingHeightFunc = () => {
      let calculatedHeight = "calc(1.5em + .75rem + 2px)";
      if (
        this.state.selectedTempleteDescription &&
        this.state.selectedTempleteDescription.length > 45
      ) {
        calculatedHeight = "calc((1.5em + .75rem + 2px)*2)";
      }
      return calculatedHeight;
    }
    const modules = {
      toolbar: {
        container: [
          [{ 'header': [] }],
          // [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
          ['bold', 'italic', 'underline'],
          ['link'],
          [{ 'list': 'ordered' }, { 'list': 'bullet' }],
          // [{ 'align': [] }],
          ['clean'],
          ['image'] // Add the image button to the toolbar
        ],
        // handlers: {
        //   'image': imageHandler, // Use custom handler for image
        // }
      }
    };
    return (
      <Modal
        centered
        size="xl"
        backdrop="static"
        onHide={this.props.onClose}
        show={this.props.show}
        style={{ zIndex: 1201 }}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            NewsLetter
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '78vh', overflow: 'auto' }}>
          <Show when={this.state.status === PageStatus.Loading}>
            <div className="d-flex justify-content-center w-100 p-5">
              <Spinner animation="border" variant="primary" />
            </div>
          </Show>

          <Alert variant="danger" show={this.state.status === PageStatus.Error}>
            {this.state.error}
          </Alert>

          <form onSubmit={this.props.handleSubmit(
            (event) => this.onSubmit(),
          )}
          >
            {/* ================================================================= */}
            <div className="row">
              <div className="col-12">
                <label htmlFor="notificationType">Notification Type *</label>
                <div className="d-flex">
                  <div className="form-check me-3 mx-3">
                    <input
                      type="radio"
                      value="email"
                      checked={this.state.notificationType === 'email'}
                      onChange={this.handleChangeCheckbox}
                      id="email"
                    />
                    <label className="form-check-label" htmlFor="email">Email</label>
                  </div>

                  {/* ===== DISABLED 2026-05-04 — SMS/WhatsApp newsletter channels =====
                      To re-enable: uncomment + see Item #12 implementation notes
                      ====================================================================
                  <div className="form-check mx-3">
                    <input
                      type="radio"
                      value="sms"
                      checked={this.state.notificationType === 'sms'}
                      onChange={this.handleChangeCheckbox}
                      id="sms"
                    />
                    <label className="form-check-label" htmlFor="sms">SMS</label>
                  </div>
                  */}
                  {/* ===== DISABLED 2026-05-04 — SMS/WhatsApp newsletter channels =====
                      To re-enable: uncomment + see Item #12 implementation notes
                      ====================================================================
                  <div className="form-check mx-3">
                    <input
                      type="radio"
                      value="whatsapp"
                      checked={this.state.notificationType === 'whatsapp'}
                      onChange={this.handleChangeCheckbox}
                      id="whatsapp"
                    />
                    <label className="form-check-label" htmlFor="whatsapp">WhatsApp</label>
                  </div>
                  */}
                  <div className="form-check mx-3">
                    <input
                      type="radio"
                      value="userId"
                      checked={this.state.notificationType === 'userId'}
                      onChange={this.handleChangeCheckbox}
                      id="userId"
                    />
                    <label className="form-check-label" htmlFor="userId">Inbox</label>
                  </div>
                </div>
              </div>
            </div>


            {/* ======================================================= */}
            <div className="row mt-2">
              <div className="col">
                <label htmlFor="name">Name</label>
                <input
                  className="form-control"
                  name="name"
                  onChange={(e) => this.setState({ name: e.target.value })}
                  value={this.state.name}
                  placeholder="Enter here"
                />
              </div>
              <div className="col">
                <label htmlFor="category">Category</label>
                <select
                  name="category"
                  id="category"
                  className="form-control"
                  value={this.state.cat}
                  onChange={(e) => this.setState((prev) => ({ cat: prev.notificationType != 'userId' ? "" : e.target.value }))}
                  disabled={this.state.notificationType != 'userId'}
                  required={this.state.notificationType == 'userId'}
                >
                  <option value="">{this.state.notificationType !== 'userId' ? "Select 'Inbox' type first" : "--Choose--"}</option>
                  <option value="surveyRelated">Survey Related</option>
                  <option value="rewardRelated">Reward Related</option>
                  <option value="redemptionRelated">Redemption Related</option>
                  <option value="general">General</option>
                </select>
              </div>
            </div>

            <div className="row mt-2">
              <div className="col">
                <label htmlFor="description">Subject</label>
                <input
                  className="form-control"
                  type="subject"
                  name="subject"
                  onChange={(e) => this.setState({ subject: e.target.value })}
                  value={this.state.subject}
                  placeholder="Enter here"

                />
              </div>
              <div className={`col ${this.state.showHideSelectTempField} d-flex flex-column`}>
                <label htmlFor="description">Select Template</label>
                <button ref={this.selectRef} onClick={this.showOptionsValue} type="button" className='p-0'>
                  <div className="custom-dropdown">
                    <div
                      name="selectTemplate"
                      id="selectTemplate"
                      className={this.state.selectedTempleteDescription ? ' setCustomHeight' : "form-control"}
                      style={{
                        cursor: 'pointer',
                        height: calculatingHeightFunc()
                      }}
                    >
                      <div className={`d-flex justify-content-between`}>
                        {this.state.selectedTempleteDescription ||
                          <>
                            <span>--Choose--</span>
                            <span style={{ fontSize: "0.6rem" }}><em className='fa fa-chevron-down'></em></span>
                          </>
                        }
                      </div>
                    </div>
                    {this.state.showHideCustomSelectBox &&
                      <div ref={this.optionsRef} className="template-list">
                        {this.state.allTempletes.length > 0 ? (
                          this.state.allTempletes.map((item) => (
                            <div key={item.id} className={`template-item`}>
                              <button type='button' className={`w-90 onlyTextHighlight rounded-left d-flex flex-row bg-transparent p-1 ${this.state.tempId == item.id ? "selected_temp_name" : ""}`} style={{ cursor: 'pointer', marginLeft: '0.5rem' }} onClick={() => { this.selectTempleteDescription(item.id, item.name) }}>{item.name}</button>
                              <button
                                className="w-10 delete-icon rounded-right px-3 p-1 deleteIconBgSet"
                                onClick={() => this.deleteTemplate(item.id)}
                                title='Delete option'
                              >
                                <i className="fa fa-trash text-danger cursor-pointer"></i>
                              </button>
                            </div>
                          ))
                        ) :
                          (<span>No templates available</span>)}
                      </div>
                    }
                  </div>
                </button>
              </div>
            </div>
            {notificationType !== 'whatsapp' && notificationType !== 'sms' && (
              <div className="row mt-2">
                <div className="col">
                  <label htmlFor="body">Body</label>
                  <ReactQuill
                    theme="snow" // other themes: 'bubble', 'core'
                    value={this.state.body}
                    onChange={(e) => this.setState({ body: e })}
                    modules={modules}
                  // readOnly={true}
                  />
                </div>
              </div>
            )}
            <p className="text-muted small mb-2 mt-3"><em>Select a notification type above to enable the corresponding fields below.</em></p>
            <div className="row mt-2">
              <div className="col-6">
                <label htmlFor="text">Emails</label>
                <CreatableSelect
                  name='emails'
                  id='emails'
                  isMulti
                  onChange={(selectedOptions) => this.handleChange(selectedOptions, 'emails')}
                  onCreateOption={(inputValue) => this.handleCreateOption(inputValue, 'emails')}
                  value={this.state.emails}
                  isDisabled={this.state.disableEmails}
                  placeholder={this.state.disableEmails ? "Select 'Email' notification type first" : "Type and press enter to add emails..."}
                />
              </div>
              <div className="col-6">
                <label htmlFor="bulkEmail">Choose bulk emails</label>
                <input
                  type="file"
                  accept=".csv"
                  className="form-control"
                  id="bulkEmail"
                  name="bulkEmail"
                  onChange={(event) => this.handleFileChange(event, 'emails')}
                  disabled={this.state.disableBulkEmailSheet}
                />
              </div>
            </div>
            {/* ====================== Phone Numbers==================== */}

            <div className="row ">
              <div className="col-6">
                <label htmlFor="phoneNumbers" className="mt-2 ">Phone Numbers</label>
                <CreatableSelect
                  name='phoneNumbers'
                  id='phoneNumbers'
                  isMulti={false} // Change this to false for single select
                  onChange={(selectedOptions) => this.handleChange(selectedOptions, 'phoneNumbers')}
                  onCreateOption={(inputValue) => this.handleCreateOption(inputValue, 'phoneNumbers')}
                  onInputChange={(inputValue) => this.handleInputChange(inputValue)}
                  value={this.state.phoneNumbers}
                  isDisabled={this.state.disablePhoneNumbers}
                  placeholder={this.state.disablePhoneNumbers ? "Select 'SMS' or 'WhatsApp' notification type first" : "Type and press enter to add phone number..."}
                />
              </div>
              <div className="col-6">
                <label htmlFor="bulkEmail" className="mt-2 ">Choose bulk Number</label>
                <input
                  type="file"
                  accept=".csv"
                  className="form-control"
                  id="bulkPhoneNumbers"
                  name="bulkPhoneNumbers"
                  onChange={(event) => this.handleFileChange(event, 'phoneNumbers')}
                  disabled={this.state.disablebulkPhoneNumbersSheet}
                />
              </div>
            </div>
            {/* ===================User IDs================== */}


            <div className="row ">
              <div className="col-6">
                <label htmlFor="userIds" className="mt-2 ">User IDs</label>
                <CreatableSelect
                  name='userIds'
                  id='userIds'
                  isMulti={false} // Change this to false for single select
                  onChange={(selectedOptions) => this.handleChange(selectedOptions, 'userIds')}
                  onCreateOption={(inputValue) => this.handleCreateOption(inputValue, 'userIds')}
                  value={this.state.userIds}
                  isDisabled={this.state.disableUserIds}
                  placeholder={this.state.disableUserIds ? "Select 'Inbox' notification type first" : "Type and press enter to add user ID..."}
                />
              </div>
              <div className="col-6">
                <label htmlFor="bulkEmail" className="mt-2 ">Choose bulk User IDs</label>
                <input
                  type="file"
                  accept=".csv"
                  className="form-control "
                  id="bulkuserIds"
                  name="bulkuserIds"
                  onChange={(event) => this.handleFileChange(event, 'userIds')}
                  disabled={this.state.disablebulkuserIdsSheet}
                />
              </div>
            </div>
            {/* ===========ADD FILED ENHANCEMENT================ */}


            <Show when={this.props.id}>
              <div className="form-group">
                <label htmlFor='sample'>Samples</label>
                <Select
                  name='sample_id'
                  id='sample_id'
                  onChange={this.handleSampleChange}
                  value={this.state.selectedSampleOption}
                  options={this.state.samples}
                />
              </div>
            </Show>
            <Alert variant="danger" show={!!this.state.error} className="mt-2">
              {this.state.error}
            </Alert>

            <div className="d-flex align-items-center mt-2">
              <button
                type="submit"
                // disabled={!this.state.body || !this.state.emails.length}
                // disabled={!this.state.body}
                className="btn btn-primary mr-3"
              >
                Submit
              </button>

              <Show when={this.state.status === PageStatus.Submitting}>
                <Spinner animation="border" variant="primary" />
              </Show>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    );
  }
}

const dataFormRedux = reduxForm<any, any>({
  form: 'dataForm',
})(Form);

const dataFormWithRouter = withRouter(dataFormRedux);

export { dataFormWithRouter as Form };
